import { Music } from 'lucide-react'
import NowPlayingTile from './NowPlayingTile'
import PlaylistGrid from './PlaylistGrid'
import TopTracksTile from './TopTracksTile'
import ArtistDiscoveryTile from './ArtistDiscoveryTile'

export default function MusicSection() {
  return (
    <section id="music" className="scroll-mt-32 py-16">
      <header className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="text-4xl font-heading font-semibold amber-gradient-text">Music</h2>
          <p className="text-amber-100/70 mt-1 max-w-prose">
            What's looping while the cursor blinks. Not curated, just honest.
          </p>
        </div>
        <Music className="text-amber-300/60" size={28} />
      </header>

      <div className="space-y-8">
        <NowPlayingTile />
        <PlaylistGrid />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <TopTracksTile />
          <ArtistDiscoveryTile />
        </div>
      </div>
    </section>
  )
}
